import Vue from 'vue'
import { Toast } from 'vant'
// import API from '@/api'
import { platform } from '@/defines/environment' // eslint-disable-line camelcase
import shopLeaseDefaultImg from '@/images/empty/shop-lease-default.png'
import { Bridge } from '@mc/mc-jsbridge'
import { checkAppVersion } from './native_interactions/native_redirect'
import { getGoodDefaultImg } from './utils'
/**
 * [商品图片加载失败]
 * @param  {Object} e
 * @return  {string} src
 */
export const imgLoadFail = (e, defaultImg) => {
  if (defaultImg === 'HIDE') {
    e.target.style.display = 'none'
    return
  }

  defaultImg = defaultImg || getGoodDefaultImg()
  if (e.target.src !== defaultImg) {
    e.target.src = defaultImg
  }
}
/**
 * [店铺无忧图片加载失败]
 * @param  {Object} e
 * @return  {string} src
 */
export const shopImgLoadFail = (e, defaultImg) => {
  if (defaultImg === 'HIDE') {
    e.target.style.display = 'none'
    return
  }

  defaultImg = defaultImg || shopLeaseDefaultImg
  if (e.target.src !== defaultImg) {
    e.target.src = defaultImg
  }
}

/*
 * 阿里云规则
 * https://help.aliyun.com/document_detail/50039.html?spm=5176.doc44687.2.13.yTDYWa
 */
export const imgFormatFilter = (src, imgWidth = 0, imgHeight = 0) => {
  if (src && src.indexOf('oss') > 0) {
    // 阿里云:前端主动添加size、format属性
    const formatList = []
    if (imgWidth !== 0 || imgHeight !== 0) {
      formatList.push(
        `/resize,m_fixed,w_${parseInt(imgWidth)},h_${parseInt(imgHeight)}`
      )
    }
    if (platform !== 'ios') {
      // eslint-disable-line camelcase
      formatList.push('/format,webp')
    }
    if (src.indexOf('watermark') > 0) {
      if (src.indexOf('stage') > 0) {
        formatList.push(
          '/watermark,image_b3NzL3Rlc3QvMjdkNDc3ZWQ4NjYwNWQ2ZjJiM2JmNmIzNzc1MGNhNDUucG5n,g_center'
        )
      } else {
        formatList.push(
          '/watermark,image_b3NzL2RlZmF1bHQvYzA3YmI4ODIzNmYxNjEzMDViMWRkOGI0ZmE0NGZiMzgucG5n,g_center'
        )
      }
    }
    return src.split('?')[0] + '?x-oss-process=image' + formatList.join('')
  }
  return src
}

// export const imgUpload = ({ file, callBack, data, subPath }) => {
//   if (
//     'jpg|jpeg|gif|bmp|png'.indexOf(
//       file.type.substring(file.type.lastIndexOf('/') + 1).toLowerCase()
//     ) < 0
//   ) {
//     Toast({
//       message: '抱歉只能上传图片文件'
//     })
//     return
//   }

//   API.getUploadKey(data).then(
//     res => {
//       const { data } = res
//       if (data.ret === 1 && data.data) {
//         onLoad({
//           key: data.data,
//           file,
//           callBack,
//           subPath
//         })
//       } else {
//         Toast({
//           message: `图片上传失败, ${data.error && data.error.msg}`
//         })
//       }
//     },
//     err => {
//       console.log(err)
//     }
//   )
// }

export const onLoad = ({ key, file, callBack, subPath }) => {
  const formData = new FormData()
  formData.append('file', file)
  formData.append(
    'object',
    `${subPath || ''}${new Date().getTime()}${encodeURIComponent(
      file.name.toLowerCase()
    )}`
  )

  Vue.http
    .post(key.oss_upload_url + '/api/oss/uploadFile', formData, {
      headers: {
        'Oss-Auth': key.oss_auth,
        'Content-Type': 'application/x-www-form-urlencoded',
        'App-Code': key.app_code
      }
    })
    .then(
      res => {
        const { data } = res
        if (data.data) {
          callBack()(data)
        } else {
          Toast({
            message: data.error && data.error.msg
          })
        }
      },
      err => {
        console.log(err)
        Toast({
          message: '图片上传失败，请稍候再试'
        })
      }
    )
}

// export const imgUploadP = ({ file, data, subPath }) => {
//   if (
//     'jpg|jpeg|gif|bmp|png'.indexOf(
//       file.type.substring(file.type.lastIndexOf('/') + 1).toLowerCase()
//     ) < 0
//   ) {
//     Toast('抱歉只能上传图片文件')
//     return Promise.reject('抱歉只能上传图片文件')
//   }
//   return API.getUploadKey(data)
//     .then(res => {
//       const { data } = res
//       if (data.ret === 1 && data.data) {
//         return onLoadP({
//           key: data.data,
//           file,
//           subPath
//         })
//       } else {
//         return Promise.reject({
//           message: `图片上传失败, ${data.error && data.error.msg}`
//         })
//       }
//     })
//     .catch(err => {
//       console.log(err)
//       if (err instanceof Error) {
//         Toast(`图片上传失败，${err.message}`)
//       } else if (err.message) {
//         Toast(err.message)
//       } else if (err.native_type === 'xhr_error') {
//         Toast('图片上传失败，网络不给力，请换个网络再试')
//       }
//       return Promise.reject(err)
//     })
// }

export const onLoadP = ({ key, file, subPath }) => {
  const formData = new FormData()
  formData.append('file', file)
  formData.append(
    'object',
    `${subPath || ''}${new Date().getTime()}${encodeURIComponent(file.name)}`
  )

  return Vue.http
    .post(key.oss_upload_url + '/api/oss/uploadFile', formData, {
      headers: {
        'Oss-Auth': key.oss_auth,
        'Content-Type': 'application/x-www-form-urlencoded',
        'App-Code': key.app_code
      }
    })
    .then(res => {
      const { data } = res
      if (data.data) {
        return Promise.resolve(data)
      } else {
        return Promise.reject({ message: '图片上传失败，请稍候再试' })
      }
    })
    .catch(err => {
      return Promise.reject(err)
    })
}

// export const imageUpload = async ({ file, path }) => {
//   const formData = new FormData()
//   formData.append('file', file)
//   formData.append(
//     'object',
//     `${path || ''}${new Date().getTime()}${encodeURIComponent(file.name)}`
//   )

//   try {
//     const { data } = await API.uploadImage(formData)
//     if (data.data) {
//       return Promise.resolve(data)
//     } else {
//       return Promise.reject({ message: '图片上传失败，请稍候再试' })
//     }
//   } catch (error) {
//     return Promise.reject(error)
//   }
// }

export const downloadPictureToAlbum = (imgLink, callback) => {
  if (bridgePrepared()) {
    return Bridge.downloadPictureToAlbum(imgLink, callback)
  } else {
    window.appMethod && window.appMethod.downloadPictureToAlbum(imgLink)
    // NOTICE: 由于老 API 没有回调，所以在兼容模式下，callback 或者 then 都是不准确的。
    if (callback && typeof callback === 'function') {
      callback()
    } else {
      return Promise.resolve()
    }
  }
}

export const bridgePrepared = (appVersion = '2.8.0') => {
  // eslint-disable-next-line camelcase
  if (platform === 'ios') {
    return Bridge.prepared
    // eslint-disable-next-line camelcase
  } else if (platform === 'android') {
    return checkAppVersion(appVersion)
    // eslint-disable-next-line camelcase
  }
}
